<template>
  <div class="add-checked dialog">
    <ipub-model @confirm="confirm"
                @cancel="cancel"
                :visable="isVisable"
                title="Checked Note">
      <ipub-textarea class="mar-b-10"
                     :autoSize="{ cols: '', rows: '10' }"
                     v-model="checkRemark" />
    </ipub-model>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import { editorManuscript } from '@/api/editor'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: true,
    },
    checked: {
      type: Boolean,
      default: true,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      },
    },

  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  data () {
    return {
      checkRemark: ""
    }

  },
  mounted () {

  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.checkRemark = ''
      } else {
        this.checkRemark = this.inputData.checkRemark
      }
    }
  },
  methods: {
    async confirm () {

      await editorManuscript.check(this.inputData.id, {
        checkRemark: this.checkRemark,
        sign: this.inputData.sign,
        version: this.inputData.version,
      })
      this.$message.success({ title: 'Success', content: `This Checked Note has been saved!` })


      this.$emit('confirm', this.inputData)
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style>
</style>